import { gql } from 'graphql-request';

export const listAutomationTasks = gql`
  query listWA_AutomationTasks(
    $filter: AutomationTaskFilterInput
    $cursors: AutomationTaskCursorsInput
  ) {
    wawiAssist {
      listWA_AutomationTasks(filter: $filter, cursors: $cursors) {
        items {
          taskName
          id: taskId
          isActive
          taskType
          scheduleCron
          schedule {
            hours
            minutes
            month
            monthDay
            weekDay
          }
          nextExecution
          additonalInfo {
            lastExecutedAt
          }
          targetLambdaPayload
        }
        cursors {
          hasNext
          after
        }
      }
    }
  }
`;

export const getAutomationTask = gql`
  query getWA_AutomationTask($id: ID!) {
    wawiAssist {
      getWA_AutomationTask(id: $id) {
        id: taskId
        taskName
        isActive
        taskType
        scheduleCron
        schedule {
          hours
          minutes
          month
          monthDay
          weekDay
        }
        nextExecution
        additonalInfo {
          lastExecutedAt
        }
        targetLambdaPayload
      }
    }
  }
`;

export const createAutomationTask = gql`
  mutation createWA_AutomationTask($params: AutomationCreateInput!) {
    wawiAssist {
      createWA_AutomationTask(params: $params) {
        id: taskId
        scheduleCron
      }
    }
  }
`;

export const updateAutomationTask = gql`
  mutation updateWA_AutomationTask($id: ID!, $fields: AutomationTaskUpdateInput!) {
    wawiAssist {
      updateWA_AutomationTask(id: $id, fields: $fields) {
        id: taskId
        taskName
        isActive
        taskType
        scheduleCron
        schedule {
          hours
          minutes
          month
          monthDay
          weekDay
        }
        nextExecution
        additonalInfo {
          lastExecutedAt
        }
        targetLambdaPayload
      }
    }
  }
`;

export const deleteAutomationTask = gql`
  mutation deleteWA_AutomationTask($id: ID!) {
    wawiAssist {
      deleteWA_AutomationTask(id: $id) {
        id: taskId
      }
    }
  }
`;

export const runAutomationTask = gql`
  mutation runWA_AutomationTask($id: ID!) {
    wawiAssist {
      runWA_AutomationTask(id: $id)
    }
  }
`;
